import { State } from 'xstate';
import { resumeSubscription } from './resumeSubscription';

type ResumeSubscriptionsMachine = typeof resumeSubscription;
type ResumeSubscriptionState = State<ResumeSubscriptionsMachine['context']>;

export const getResumeSubscriptionStatus = (
  machineState: ResumeSubscriptionState
) => ({
  resumeSubscriptionLoading: machineState.matches('resumeSubscription'),
  resumeSubscriptionSuccess: machineState.matches('success'),
  resumeSubscriptionError: machineState.matches('error'),
});

export const getErrorCode = (machineState: ResumeSubscriptionState) => {
  return machineState.context.error;
};
export const getResumptionConfig = (machineState: ResumeSubscriptionState) => {
  return machineState.context.resumptionCharge;
};

export const resumeSubscriptionSelectors = {
  getResumeSubscriptionStatus,
  getErrorCode,
  getResumptionConfig,
};
